<!-- Mobile Sidebar -->
<p-drawer [(visible)]="sidebarOpen" [baseZIndex]="10000" class="lg:hidden" position="left">
  <div class="flex flex-col h-full">
    <div class="flex items-center justify-center px-4 py-3">
      <div [ngSwitch]="logo.type">
        <img
          *ngSwitchCase="'image'"
          [alt]="logo.alt"
          [class]="logo.class || 'mx-auto h-24 w-auto'"
          [src]="logo.src"
        />
        <div
          *ngSwitchCase="'svg'"
          [class]="logo.class || 'h-8 w-auto mx-auto'"
          [innerHTML]="sanitizedSvgContent"
        ></div>
        <div *ngSwitchDefault class="h-8 mx-auto">
          <svg
            class="size-6"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>

    <nav class="flex-1 overflow-y-auto px-4 pt-6">
      <ul class="space-y-4">
        @for (item of navigation; track item.id || item.href) {
          <!-- Item con hijos -->
          @if (item.children && item.children.length > 0) {
            <li>
              <div
                class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-primary-700 dark:text-primary-300 hover:bg-primary-100 dark:hover:bg-primary-700"
                [ngClass]="{
                  'bg-primary-100 text-primary-600 dark:bg-primary-800 dark:text-primary-400':
                    item.current,
                }"
              >
                <!-- Parte clickeable para navegación -->
                <a
                  [routerLink]="item.href"
                  class="flex items-center gap-3 flex-1"
                  (click)="sidebarOpen = false"
                >
                  <i
                    [class]="item.icon + ' text-lg'"
                    [ngClass]="{
                      'text-primary-600': item.current,
                      'text-primary-400': !item.current,
                    }"
                  ></i>
                  <span class="flex-1 text-left">{{ item.name }}</span>
                </a>
                <!-- Botón para expandir/colapsar -->
                <button
                  (click)="toggle(item.id || item.href)"
                  [attr.aria-expanded]="isExpanded(item.id || item.href)"
                  class="p-1 hover:bg-primary-200 dark:hover:bg-primary-600 rounded transition-colors"
                  type="button"
                >
                  <i
                    class="pi text-sm"
                    [ngClass]="
                      isExpanded(item.id || item.href) ? 'pi-chevron-up' : 'pi-chevron-down'
                    "
                  ></i>
                </button>
              </div>

              @if (isExpanded(item.id || item.href)) {
                <ul class="mt-1 ml-7 space-y-1">
                  @for (child of item.children; track child.id || child.href) {
                    <li>
                      <a
                        [routerLink]="child.disabled ? null : child.href"
                        (click)="child.disabled ? $event.preventDefault() : (sidebarOpen = false)"
                        class="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-primary-700 dark:text-primary-300"
                        [ngClass]="{
                          'bg-primary-100 text-primary-600 dark:bg-primary-800 dark:text-primary-400':
                            child.current && !child.disabled,
                          'hover:bg-primary-100 dark:hover:bg-primary-700': !child.disabled,
                          'opacity-50 cursor-not-allowed': child.disabled,
                        }"
                      >
                        <i
                          [class]="child.icon + ' text-sm'"
                          [ngClass]="{
                            'text-primary-600': child.current && !child.disabled,
                            'text-primary-400': !child.current || child.disabled,
                          }"
                        ></i>
                        <span class="text-inherit">{{ child.name }}</span>
                      </a>
                    </li>
                  }
                </ul>
              }
            </li>
          } @else {
            <!-- Item simple -->
            <li>
              <a
                [routerLink]="item.href"
                (click)="sidebarOpen = false"
                class="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium"
                [ngClass]="{
                  'bg-primary-100 text-primary-600 dark:bg-primary-800 dark:text-primary-400':
                    item.current,
                  'text-primary-700 dark:text-primary-300 hover:bg-primary-100 dark:hover:bg-primary-700':
                    !item.current,
                }"
              >
                <i
                  [class]="item.icon + ' text-lg'"
                  [ngClass]="{
                    'text-primary-600': item.current,
                    'text-primary-400': !item.current,
                  }"
                ></i>
                {{ item.name }}
              </a>
            </li>
          }
        }
      </ul>
    </nav>

    <!-- Footer -->
    <div class="mt-auto pt-4">
      <ng-container *ngTemplateOutlet="footer"></ng-container>
    </div>

    <ng-template #footer>
      <div class="flex items-center justify-between gap-4">
        <!-- Footer personalizado si se proporciona -->
        @if (footerConfig.customElements && footerConfig.customElements.length > 0) {
          @for (element of footerConfig.customElements; track $index) {
            <!-- Renderizar HTML personalizado -->
            @if (element.type === 'html') {
              <div [innerHTML]="element.content"></div>
            }

            <!-- Renderizar componentes específicos -->
            @if (element.type === 'component') {
              @if (element.content === 'lib-theme-selector') {
                <lib-theme-selector
                  [variant]="element.props?.variant || 'toggle'"
                ></lib-theme-selector>
              }
              @if (element.content === 'lib-i18n') {
                <lib-i18n
                  [class]="element.props?.class || 'hidden'"
                  [variant]="element.props?.variant || 'switch'"
                ></lib-i18n>
              }
            }
          }
        }

        <!-- Footer por defecto -->
        @if (footerConfig.showDefault) {
          <div class="flex flex-col items-center justify-between gap-4">
            <lib-theme-selector variant="toggle"></lib-theme-selector>
            <lib-i18n class="hidden"></lib-i18n>
          </div>
        }
      </div>
    </ng-template>
  </div>
</p-drawer>

<!-- Static sidebar for desktop -->
<div
  [ngClass]="{
    'lg:w-72 px-6': !desktopSidebarCollapsed,
    'lg:w-20 px-3': desktopSidebarCollapsed,
  }"
  class="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col border-r border-gray-200 dark:border-gray-700 bg-white dark:bg-black py-4 transition-all duration-500 ease-in-out"
>
  <div [ngSwitch]="logo.type" class="flex items-center justify-center">
    <img
      *ngSwitchCase="'image'"
      [alt]="logo.alt"
      [class]="getDesktopLogoImageClass()"
      [src]="logo.src"
    />
    <div
      *ngSwitchCase="'svg'"
      [class]="logo.class || 'h-auto w-auto mx-auto'"
      [innerHTML]="sanitizedSvgContent"
    ></div>
    <div *ngSwitchDefault class="h-8 mx-auto">
      <svg
        class="size-6"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0 1 12 12.75Zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 0 1-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 0 0 2.248-2.354M12 12.75a2.25 2.25 0 0 1-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 0 0-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 0 1 .4-2.253M12 8.25a2.25 2.25 0 0 0-2.248 2.146M12 8.25a2.25 2.25 0 0 1 2.248 2.146M8.683 5a6.032 6.032 0 0 1-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0 1 15.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 0 0-.575-1.752M4.921 6a24.048 24.048 0 0 0-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 0 1-5.223 1.082"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>

  <!-- Static sidebar for desktop -->
  <nav class="flex-1 overflow-y-auto pt-4">
    <ul class="space-y-1">
      @for (item of navigation; track item.id || item.href) {
        <!-- Item con hijos -->
        @if (item.children && item.children.length > 0) {
          <li>
            <div
              [ngClass]="{
                'bg-primary-100 text-primary-600 dark:bg-primary-800 dark:text-primary-400':
                  item.current,
                'justify-center': desktopSidebarCollapsed,
              }"
              class="w-full flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium text-primary-700 dark:text-primary-300 hover:bg-primary-100 dark:hover:bg-primary-700"
            >
              <!-- Parte clickeable para navegación -->
              <a
                [routerLink]="item.href"
                [attr.title]="desktopSidebarCollapsed ? item.name : null"
                [ngClass]="{ 'justify-center': desktopSidebarCollapsed }"
                class="flex items-center gap-3 flex-1"
                (click)="sidebarOpen = false"
              >
                <i
                  [class]="item.icon + ' text-lg'"
                  [ngClass]="{
                    'text-primary-600': item.current,
                    'text-primary-400': !item.current,
                  }"
                ></i>
                @if (!desktopSidebarCollapsed) {
                  <span class="flex-1 text-left">{{ item.name }}</span>
                }
              </a>
              <!-- Botón para expandir/colapsar -->
              <button
                (click)="toggle(item.id || item.href)"
                [attr.aria-expanded]="isExpanded(item.id || item.href)"
                [hidden]="desktopSidebarCollapsed"
                class="p-1 hover:bg-primary-200 dark:hover:bg-primary-600 rounded transition-colors"
                type="button"
              >
                <i
                  class="pi text-sm"
                  [ngClass]="isExpanded(item.id || item.href) ? 'pi-chevron-up' : 'pi-chevron-down'"
                ></i>
              </button>
            </div>

            @if (!desktopSidebarCollapsed && isExpanded(item.id || item.href)) {
              <ul class="mt-1 ml-7 space-y-1">
                @for (child of item.children; track child.id || child.href) {
                  <li>
                    <a
                      [routerLink]="child.disabled ? null : child.href"
                      (click)="child.disabled ? $event.preventDefault() : (sidebarOpen = false)"
                      class="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-primary-700 dark:text-primary-300"
                      [ngClass]="{
                        'bg-primary-100 text-primary-600 dark:bg-primary-800 dark:text-primary-400':
                          child.current && !child.disabled,
                        'hover:bg-primary-100 dark:hover:bg-primary-700': !child.disabled,
                        'opacity-50 cursor-not-allowed': child.disabled,
                      }"
                    >
                      <i
                        [class]="child.icon + ' text-sm'"
                        [ngClass]="{
                          'text-primary-600': child.current && !child.disabled,
                          'text-primary-400': !child.current || child.disabled,
                        }"
                      ></i>
                      <span class="text-inherit">{{ child.name }}</span>
                    </a>
                  </li>
                }
              </ul>
            }
          </li>
        } @else {
          <!-- Item simple -->
          <li>
            <a
              [routerLink]="item.href"
              (click)="sidebarOpen = false"
              [attr.title]="desktopSidebarCollapsed ? item.name : null"
              [attr.data-cy]="'nav-' + item.href.slice(1)"
              class="flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium"
              [ngClass]="{
                'bg-primary-100 text-primary-600 dark:bg-primary-800 dark:text-primary-400':
                  item.current,
                'text-primary-700 dark:text-primary-300 hover:bg-primary-100 dark:hover:bg-primary-700':
                  !item.current,
                'justify-center': desktopSidebarCollapsed,
              }"
            >
              <i
                [class]="item.icon + ' text-lg'"
                [ngClass]="{ 'text-primary-600': item.current, 'text-primary-400': !item.current }"
              ></i>
              @if (!desktopSidebarCollapsed) {
                {{ item.name }}
              }
            </a>
          </li>
        }
      }
    </ul>
  </nav>

  <p-button
    (onClick)="toggleDesktopSidebar()"
    [attr.aria-label]="desktopSidebarCollapsed ? 'Expandir sidebar' : 'Colapsar sidebar'"
    [ngClass]="{
      'mx-auto': desktopSidebarCollapsed,
      'ml-auto': !desktopSidebarCollapsed,
    }"
    variant="outlined"
  >
    <i
      [class]="
        desktopSidebarCollapsed
          ? 'pi pi-angle-double-right text-base'
          : 'pi pi-angle-double-left text-base'
      "
    ></i>
  </p-button>

  <!-- Footer -->
  <div class="mt-auto pt-4">
    <ng-container *ngTemplateOutlet="footer"></ng-container>
  </div>

  <ng-template #footer>
    <div [ngClass]="{ 'items-center': !desktopSidebarCollapsed }" class="flex w-full gap-4">
      <!-- Footer personalizado si se proporciona -->
      <div
        [ngClass]="{
          'grid grid-cols-1 justify-center gap-3 w-full': desktopSidebarCollapsed,
          'flex flex-row items-center gap-4 mr-auto': !desktopSidebarCollapsed,
        }"
      >
        @if (footerConfig.customElements && footerConfig.customElements.length > 0) {
          @for (element of footerConfig.customElements; track $index) {
            @if (element.type === 'html') {
              <div [innerHTML]="element.content"></div>
            }

            @if (element.type === 'component') {
              @if (element.content === 'lib-theme-selector') {
                <div [ngClass]="{ 'w-full flex justify-center': desktopSidebarCollapsed }">
                  <lib-theme-selector
                    [buttonClass]="desktopSidebarCollapsed ? '!w-10 !h-10 !p-0' : ''"
                    [containerClass]="desktopSidebarCollapsed ? 'w-full flex justify-center' : ''"
                    [showLabel]="false"
                    [variant]="element.props?.variant || 'toggle'"
                  ></lib-theme-selector>
                </div>
              }
              @if (element.content === 'lib-i18n') {
                <div [ngClass]="{ 'w-full flex justify-center': desktopSidebarCollapsed }">
                  <lib-i18n
                    [buttonClass]="desktopSidebarCollapsed ? '!w-10 !h-10 !p-0' : ''"
                    [class]="element.props?.class || 'hidden'"
                    [containerClass]="desktopSidebarCollapsed ? 'w-full flex justify-center' : ''"
                    [variant]="element.props?.variant || 'switch'"
                  ></lib-i18n>
                </div>
              }
            }
          }
        }

        @if (footerConfig.showDefault) {
          <div
            [ngClass]="{ 'w-full': desktopSidebarCollapsed }"
            class="flex flex-col items-center justify-center gap-4"
          >
            <lib-theme-selector
              [buttonClass]="desktopSidebarCollapsed ? '!w-10 !h-10 !p-0' : ''"
              [containerClass]="desktopSidebarCollapsed ? 'w-full flex justify-center' : ''"
              [showLabel]="false"
              variant="toggle"
            ></lib-theme-selector>
            <lib-i18n
              [buttonClass]="desktopSidebarCollapsed ? '!w-10 !h-10 !p-0' : ''"
              [containerClass]="desktopSidebarCollapsed ? 'w-full flex justify-center' : ''"
              class="hidden"
            ></lib-i18n>
          </div>
        }
      </div>
    </div>
  </ng-template>
</div>

<main
  [ngClass]="{
    'lg:pl-72': !desktopSidebarCollapsed,
    'lg:pl-20': desktopSidebarCollapsed,
  }"
  class="bg-gray-100 dark:bg-gray-900 relative transition-all duration-500 ease-in-out"
>
  <!-- Top bar -->
  <div
    [ngClass]="{
      'lg:pl-72': !desktopSidebarCollapsed,
      'lg:pl-20': desktopSidebarCollapsed,
    }"
    class="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 dark:border-gray-700 bg-white dark:bg-black px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8 transition-all duration-500 ease-in-out"
  >
    <!-- Mobile menu button -->
    <p-button
      (click)="sidebarOpen = true"
      [text]="true"
      class="lg:hidden -m-2.5 p-2.5 text-gray-700"
      icon="pi pi-bars"
      severity="secondary"
    ></p-button>

    <!-- Separator -->
    <div aria-hidden="true" class="h-6 w-px bg-gray-200 lg:hidden"></div>

    <!-- Search and actions -->
    <div class="flex flex-1 gap-x-4 justify-end lg:gap-x-6">
      <!-- Search form -->
      <ng-content select="search-form"></ng-content>

      <!-- Action buttons -->
      <div class="flex items-center gap-x-4 lg:gap-x-6">
        <!-- Profile dropdown -->
        <p-menu #profileMenu [model]="userNavigation" [popup]="true" appendTo="body"></p-menu>

        <button
          (click)="profileMenu.toggle($event)"
          class="relative flex items-center hover:bg-primary-50 dark:hover:bg-primary-900/90 rounded-lg p-1.5 transition-colors"
          data-cy="user-menu-button"
          type="button"
        >
          <span class="absolute -inset-1.5"></span>
          <span class="sr-only">Open user menu</span>
          <p-avatar icon="pi pi-user" shape="circle" size="normal"></p-avatar>
          <span class="hidden lg:flex lg:items-center">
            <span
              aria-hidden="true"
              class="ml-4 text-sm/6 font-medium text-primary-700 dark:text-primary-300 hover:bg-primary-100 hover:text-primary-300 dark:hover:text-primary-400 dark:hover:bg-primary-700"
            >
              {{ userName || ('auth.login.user' | translate) }}
            </span>
            <i class="pi pi-chevron-down ml-2 size-5 text-gray-400"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="px-4 sm:px-6 lg:px-8 py-10">
    <ng-content></ng-content>
  </div>
</main>
